/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationOwner } from '../../axios/organisationOwner'
import type {
	OrganisationOwnerError,
	OrganisationOwnerPathParams,
	OrganisationOwnerResponse,
} from '../../types/OrganisationOwner'

export const organisationOwnerMutationKey = () => [{ url: '/organisations/:organisation/owner' }] as const

export type OrganisationOwnerMutationKey = ReturnType<typeof organisationOwnerMutationKey>

export type OrganisationOwnerVariables = {
	organisation: OrganisationOwnerPathParams['organisation']
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::owner */
export function useOrganisationOwner<TContext = unknown>(
	options?: UseMutationOptions<
		OrganisationOwnerResponse,
		AxiosError<OrganisationOwnerError>,
		OrganisationOwnerVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: organisationOwnerMutationKey(),
		mutationFn: ({ organisation }: OrganisationOwnerVariables) =>
			organisationOwner(organisation, config).then(res => res.data),
		...options,
	})
}
